import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 2,
    marginBottom: 10,
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.5,
  },
  reportLeft: {
    width: "100%",
    textAlign: "left",
    marginTop: 20,
  },
  reportRight: {
    width: "50%",
    textAlign: "right",
    marginTop: 20,
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.5,
    width: "50%",
    textAlign: "left",
    //marginTop: 20,
  },
  
  reportTitlehead: {
    fontSize: 10,
    lineHeight: 1.5,
    width: "50%",
    textAlign: "left"
  },
  reportTitleRighthead: {
    fontSize: 10,
    lineHeight: 1.5,
   // width: "50%",
    //textAlign: "right"
  },
  reportTitleRight: {
    fontSize: 9,
    lineHeight: 1.5,
    //width: "50%",
    //textAlign: "right",
   // marginTop: 20,
  },
});

const AgentName = ({ invoice }) => {
  var invoice1 = JSON.stringify(invoice);
  var invoice2 = JSON.parse(invoice1);
  var invoice3 = JSON.parse(invoice2);

  //  var clientdetaild = invoice3.child[0];

  return (
    <Fragment>
      <View style={styles.titleContainer}>
        
        <View style={styles.reportLeft}>
        <Text style={styles.reportTitlehead}>
        <b>Contact Details:</b> </Text>
        <Text style={styles.reportTitle}>
        Contact Person :{" "} {invoice3.agentdetails.first_name +" " +invoice3.agentdetails.last_name}
          {"\n"}Mobile Number : {invoice3.agentdetails.mobile_number}
          {"\n"} E Mail : {invoice3.agentdetails.email}{" "}
        </Text>
        </View>

        {/* <View style={styles.reportRight}>
        <Text style={styles.reportTitleRighthead}>
          <b>Contact Details:</b> </Text>
        <Text style={styles.reportTitleRight}>
         
        Contact Person :{" "}
          {invoice3.agentdetails.first_name +
            " " +
            invoice3.agentdetails.last_name}
          {"\n"}Mobile Number : {invoice3.agentdetails.mobile_number}
          {"\n"} E Mail : {invoice3.agentdetails.email}{" "}
        </Text>
        </View> */}
       
      </View>
    </Fragment>
  );
};

export default AgentName;
